import { createUseStyles } from "react-jss";
import { ITheme } from "../../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  featureSliderType: {
    position: "relative",
    width: "100vw",
    height: window.innerHeight,
    scrollSnapAlign: "start",
    scrollSnapStop: "always",
  },
  featureImage: {
    backgroundSize: "cover",
    backgroundPosition: "center",
    height: window.innerHeight,
    width: "100%",
    objectFit: "cover",
    position: "absolute",
    top: 0,
    left: 0,
    zIndex: 1,
  },
  contentLeft: {
    width: "75%",
    display: "flex",
    boxSizing: "border-box",
    "&.isHideIcon": {
      width: "100%",
    },
  },
  infoGame: {
    position: "absolute",
    bottom: 0,
    zIndex: 3,
    width: "100vw",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    gap: theme.spacing.space24,
    background:
      "linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, rgba(0, 0, 0, 0.60) 26.5%, rgba(0, 0, 0, 0.50) 100%)",
    paddingBottom: 120,
    padding: `0 ${theme.spacing.space16}px`,
    boxSizing: "border-box",
    alignItems: "flex-end",
  },
  game: {
    width: 50,
    height: 50,
    borderRadius: "50%",
    zIndex: 1,
  },
  category: {
    width: 50,
    height: 50,
    borderRadius: "50%",
    position: "absolute",
    left: 60,
    zIndex: 0,
  },
  imgGroup: {
    display: "flex",
    flexDirection: "row",
  },
  leftContent: {
    display: "flex",
    flexDirection: "row",
    gap: theme.spacing.space16,
    border: "1px solid var(--Color-Border-bd-4, rgba(255, 255, 255, 0.80))",
    borderRadius: 100,
    padding: 8,
    height: "fit-content",
    alignItems: "center",
    width: "100%",
    minHeight: 50,
  },
  leftContentFree: {
    display: "flex",
    flexDirection: "row",
    gap: theme.spacing.space16,
    border: "1px solid var(--Color-Border-bd-4, rgba(255, 255, 255, 0.80))",
    borderRadius: 100,
    padding: theme.spacing.space8,
    height: "fit-content",
    alignItems: "center",
    width: "100%",
    minHeight: 50,
    justifyContent: "center",
    alightItem: "center",
  },
  titleContent: {
    width: "70%",
    "&.paid-game": {
      width: "60%",
      marginLeft: 30,
    },
  },
  title: {
    width: "100%",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },
  rightContent: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.space12,
  },
  enterIcon: {
    fontSize: 32,
    padding: `${theme.spacing.space12}px 0`,
  },
  favorite: {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  freeToPlay: {
    display: "flex",
    flexDirection: "row",
    gap: 8,
    lineHeight: "normal !important",
    alignItems: "center",
  },
  headerBackground: {
    background:
      "linear-gradient(180deg, rgba(0, 0, 0, 0.80) 0%, rgba(0, 0, 0, 0.00) 100%);",
    height: 100,
    width: "100vw",
    position: "absolute",
    top: 0,
    pointerEvents: "none",
  },
  icon: {
    width: 14,
  },
  iframe: {
    width: "100%",
    height: "100%",
    borderWidth: 0,
    position: "fixed",
    top: 0,
    zIndex: theme.zIndex.dialog,
    background: theme.colors.Background1,
  },
  playBtn: {
    position: "absolute",
    inset: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(transparent, rgba(0,0,0,0.45))",
    border: "none",
    cursor: "pointer",
    zIndex: 3,
  },
  iconBtn: {
    width: 64,
    height: 64,
    borderRadius: "50%",
    backgroundColor: "rgba(0,0,0,0.7)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 24,
    color: "#fff",
  },
  video: {
    position: "relative",
    zIndex: 2,
    height: window.innerHeight,
    width: "100%",
    backgroundSize: "cover",
    backgroundPosition: "center",
    objectFit: "cover",
  },
  iframeBlurred: {
    pointerEvents: "none",
    filter: "blur(6px)",
  },
}));
